import { fuseListConstants } from "../_redux-constants/";

export function fuseListReducer(
  state = {
    fuseListLoading: false,
    fuseListData: null,
    fuseListError: null,
  },
  action
) {
  switch (action.type) {
    case fuseListConstants.FUSE_LIST_LOADING:
      return Object.assign({}, state, {
        fuseListLoading: true,
        fuseListError: null,
        fuseListData: null,
      });
    case fuseListConstants.FUSE_LIST_SUCCESS:
      return Object.assign({}, state, {
        fuseListLoading: false,
        fuseListData: action.data,
      });
    case fuseListConstants.FUSE_LIST_FAILURE:
      return Object.assign({}, state, {
        fuseListLoading: false,
        fuseListData: null,
        fuseListError: action.error,
      });
    default:
      return state;
  }
}
